import siteConfig from "../config/siteConfig";

const productData = [
  {
    id: 1,
    name: "21oz Selvedge Denim Slim Cut Jeans - Indigo",
    sku: "IH-555S-21",
    brand: siteConfig.brandName,
    category: "Bottoms",
    price: 319,
    compareAtPrice: null,
    image: "/img/product-01.webp",
    images: ["/img/product-01.webp"],
    colors: ["Indigo"],
    size: [
      "28",
      "29",
      "30",
      "31",
      "32",
      "33",
      "34",
      "35",
      "36",
      "38",
      "40",
      "42",
      "44",
    ],
    material: "100% cotton Japanese selvedge denim",
    description: [
      "A close-cut jean built from substantial indigo denim that develops a personal fade pattern over time.",
      "Its balanced rise and narrow leg create a sharp silhouette without losing the character of heavyweight workwear.",
    ],
    attributes: {
      Weight: "21oz",
      Origin: "Japan",
      Fabric: "One-washed selvedge denim",
      Fit: "Slim cut, medium-high rise",
    },
    tags: ["selvedge denim", "21oz", "slim cut", "core denim"],
    features: [
      "Button fly",
      "Five-pocket construction",
      "Selvedge ID",
      "Reinforced stress points",
    ],
    stock: 18,
    featured: true,
    newArrival: false,
  },
  {
    id: 2,
    name: "21oz Selvedge Denim Straight Cut Jeans - Indigo",
    sku: "IH-634S",
    brand: siteConfig.brandName,
    category: "Bottoms",
    price: 319,
    compareAtPrice: null,
    image: "/img/product-02.webp",
    images: ["/img/product-02.webp"],
    colors: ["Indigo"],
    size: [
      "28",
      "29",
      "30",
      "31",
      "32",
      "33",
      "34",
      "35",
      "36",
      "38",
      "40",
      "42",
      "44",
    ],
    material: "100% cotton Japanese selvedge denim",
    description: [
      "A classic straight-leg jean with enough room through the thigh for comfortable everyday wear.",
      "The dense indigo cloth begins crisp and gradually softens while retaining its clean, traditional shape.",
    ],
    attributes: {
      Weight: "21oz",
      Origin: "Japan",
      Fabric: "One-washed selvedge denim",
      Fit: "Straight cut, medium rise",
    },
    tags: ["selvedge denim", "21oz", "straight cut", "core denim"],
    features: [
      "Button fly",
      "Five-pocket construction",
      "Full straight leg",
      "Leather waist patch",
    ],
    stock: 22,
    featured: true,
    newArrival: false,
  },
  {
    id: 3,
    name: "19oz Left Hand Twill Selvedge Denim Slim Straight Cut Jeans - Indigo",
    sku: "IH-666S-19L",
    brand: siteConfig.brandName,
    category: "Bottoms",
    price: 319,
    compareAtPrice: null,
    image: "/img/product-03.webp",
    images: ["/img/product-03.webp"],
    colors: ["Indigo"],
    size: [
      "28",
      "29",
      "30",
      "31",
      "32",
      "33",
      "34",
      "35",
      "36",
      "38",
      "40",
      "42",
      "44",
    ],
    material: "100% cotton left-hand twill selvedge denim",
    description: [
      "This slim-straight jean pairs a low-profile top block with a leg that stays clean from knee to hem.",
      "Left-hand twill gives the indigo surface a distinctive hand and encourages high-contrast wear marks.",
    ],
    attributes: {
      Weight: "19oz",
      Origin: "Japan",
      Fabric: "Left-hand twill selvedge denim",
      Fit: "Slim straight cut, low-medium rise",
    },
    tags: ["selvedge denim", "19oz", "left-hand twill", "slim straight"],
    features: [
      "Button fly",
      "Five-pocket construction",
      "Selvedge coin pocket",
      "Tonal chain stitching",
    ],
    stock: 14,
    featured: false,
    newArrival: false,
  },
  {
    id: 4,
    name: "25oz Selvedge Denim Slim Tapered Cut Jeans - Indigo/Black",
    sku: "IH-777-XHSib",
    brand: siteConfig.brandName,
    category: "Bottoms",
    price: 414,
    compareAtPrice: null,
    image: "/img/product-04.webp",
    images: ["/img/product-04.webp"],
    colors: ["Indigo/Black"],
    size: [
      "28",
      "29",
      "30",
      "31",
      "32",
      "33",
      "34",
      "35",
      "36",
      "38",
      "40",
      "42",
      "44",
    ],
    material: "100% cotton extra-heavy selvedge denim",
    description: [
      "An uncompromising extra-heavy jean with an indigo face and dark interior for a deep, saturated appearance.",
      "The low rise and assertive taper keep the substantial fabric looking modern and controlled.",
    ],
    attributes: {
      Weight: "25oz",
      Origin: "Japan",
      Fabric: "Indigo/black extra-heavy selvedge denim",
      Fit: "Slim tapered cut, low rise",
    },
    tags: ["selvedge denim", "25oz", "indigo black", "slim tapered"],
    features: [
      "Button fly",
      "Extra-heavy pocket bags",
      "Tapered leg",
      "Reinforced belt loops",
    ],
    stock: 9,
    featured: true,
    newArrival: false,
  },
  {
    id: 5,
    name: "16oz Slubby Selvedge Denim Relaxed Tapered Cut Jeans - Indigo",
    sku: "IH-888S-SLB",
    brand: siteConfig.brandName,
    category: "Bottoms",
    price: 290,
    compareAtPrice: null,
    image: "/img/product-05.webp",
    images: ["/img/product-05.webp"],
    colors: ["Indigo"],
    size: [
      "28",
      "29",
      "30",
      "31",
      "32",
      "33",
      "34",
      "35",
      "36",
      "38",
      "40",
      "42",
      "44",
    ],
    material: "100% cotton slubby Japanese selvedge denim",
    description: [
      "Irregular yarn texture brings visible depth to this mid-heavy indigo denim from the first wear.",
      "A roomy seat and thigh flow into a measured taper for comfort without an oversized finish.",
    ],
    attributes: {
      Weight: "16oz",
      Origin: "Japan",
      Fabric: "Slubby selvedge denim",
      Fit: "Relaxed tapered cut, high rise",
    },
    tags: ["selvedge denim", "16oz", "slubby", "relaxed tapered"],
    features: [
      "Button fly",
      "High-rise top block",
      "Textured yarn character",
      "Selvedge detailing",
    ],
    stock: 17,
    featured: false,
    newArrival: true,
  },
  {
    id: 6,
    name: '14oz Selvedge Denim "1955" Vintage Tapered Jeans - Indigo',
    sku: "IH-1955S-142",
    brand: siteConfig.brandName,
    category: "Bottoms",
    price: 294,
    compareAtPrice: null,
    image: "/img/product-06.webp",
    images: ["/img/product-06.webp"],
    colors: ["Indigo"],
    size: [
      "29",
      "30",
      "31",
      "32",
      "33",
      "34",
      "35",
      "36",
      "38",
      "40",
      "42",
      "44",
    ],
    material: "100% cotton Japanese selvedge denim",
    description: [
      "Vintage proportions and a high rise give this jean a relaxed stance rooted in mid-century workwear.",
      "The versatile 14oz cloth offers year-round comfort and a shorter break-in period than the heavier core denims.",
    ],
    attributes: {
      Weight: "14oz",
      Origin: "Japan",
      Fabric: "One-washed selvedge denim",
      Fit: "Vintage tapered cut, high rise",
    },
    tags: ["selvedge denim", "14oz", "vintage fit", "high rise"],
    features: [
      "Button fly",
      "Roomy top block",
      "Gentle leg taper",
      "Period-inspired detailing",
    ],
    stock: 12,
    featured: false,
    newArrival: true,
  },
  {
    id: 7,
    name: "21oz Selvedge Denim Type III - Indigo",
    sku: "IH-526J",
    brand: siteConfig.brandName,
    category: "Jackets",
    price: 377,
    compareAtPrice: null,
    image: "/img/product-07.webp",
    images: ["/img/product-07.webp"],
    colors: ["Indigo"],
    size: ["XS", "S", "M", "L", "XL", "XXL", "XXXL", "XXXXL"],
    material: "100% cotton Japanese selvedge denim",
    description: [
      "A compact Type III jacket cut from dense indigo denim for a structured, work-ready profile.",
      "Its clean front and short body make it an easy partner for high-rise denim or layered shirting.",
    ],
    attributes: {
      Weight: "21oz",
      Origin: "Japan",
      Fabric: "One-washed selvedge denim",
      Fit: "Regular Type III fit",
    },
    tags: ["denim jacket", "21oz", "type III", "selvedge"],
    features: [
      "Dual chest pockets",
      "Button front",
      "Adjustable waist tabs",
      "Chain-stitched seams",
    ],
    stock: 8,
    featured: true,
    newArrival: false,
  },
  {
    id: 8,
    name: "19oz Selvedge Denim Type II Jacket - Indigo",
    sku: "IHJ-139-IND",
    brand: siteConfig.brandName,
    category: "Jackets",
    price: 369,
    compareAtPrice: null,
    image: "/img/product-08.webp",
    images: ["/img/product-08.webp"],
    colors: ["Indigo"],
    size: ["XS", "S", "M", "L", "XL", "XXL", "XXXL", "XXXXL"],
    material: "100% cotton Japanese selvedge denim",
    description: [
      "This Type II jacket combines a boxier vintage shape with richly textured 19oz indigo denim.",
      "Front pleats add movement while the substantial cloth gives every crease and fade clear definition.",
    ],
    attributes: {
      Weight: "19oz",
      Origin: "Japan",
      Fabric: "Selvedge denim",
      Fit: "Boxy Type II fit",
    },
    tags: ["denim jacket", "19oz", "type II", "new arrival"],
    features: [
      "Front pleat construction",
      "Flap chest pockets",
      "Button front",
      "Adjustable hem tabs",
    ],
    stock: 16,
    featured: false,
    newArrival: true,
  },
  {
    id: 9,
    name: "17oz Duck Modified Type III Jacket - Brown",
    sku: "IH-2526J",
    brand: siteConfig.brandName,
    category: "Jackets",
    price: 348,
    compareAtPrice: null,
    image: "/img/product-09.webp",
    images: ["/img/product-09.webp"],
    colors: ["Brown"],
    size: ["XS", "S", "M", "L", "XL", "XXL", "XXXL", "XXXXL"],
    material: "100% cotton duck canvas",
    description: [
      "Dense brown duck canvas lends this modified trucker jacket a warm tone and abrasion-resistant surface.",
      "A slightly longer body and practical hand pockets make the heritage shape more useful for daily layering.",
    ],
    attributes: {
      Weight: "17oz",
      Origin: "Japan",
      Fabric: "Cotton duck canvas",
      Fit: "Modified Type III fit",
    },
    tags: ["duck canvas", "17oz", "type III", "work jacket"],
    features: [
      "Side-entry hand pockets",
      "Flap chest pockets",
      "Button front",
      "Adjustable waist tabs",
    ],
    stock: 13,
    featured: false,
    newArrival: false,
  },
  {
    id: 10,
    name: "Japanese Horsehide Rider’s Jacket - Black (Tea-Core Dyed)",
    sku: "IHJ-35-BLK",
    brand: siteConfig.brandName,
    category: "Jackets",
    price: 1480,
    compareAtPrice: null,
    image: "/img/product-10.webp",
    images: ["/img/product-10.webp"],
    colors: ["Black"],
    size: ["S", "M", "L", "XL", "XXL", "XXXL", "XXXXL"],
    material: "Tea-core dyed Japanese horsehide",
    description: [
      "A focused rider jacket shaped from black horsehide that reveals warmer undertones at high-wear areas.",
      "The minimal collarless profile keeps the weight and natural grain of the leather at the centre of the design.",
    ],
    attributes: {
      Weight: "Heavyweight",
      Origin: "Japan",
      Fabric: "Tea-core horsehide leather",
      Fit: "Regular rider fit",
    },
    tags: ["horsehide", "leather jacket", "tea-core", "rider"],
    features: [
      "Two-way front zip",
      "Zipped cuffs",
      "Quilted lining",
      "Secure interior pocket",
    ],
    stock: 4,
    featured: true,
    newArrival: false,
  },
  {
    id: 11,
    name: "12oz Whipcord Tanker Jacket - Olive Drab Green",
    sku: "IHM-47-ODG",
    brand: siteConfig.brandName,
    category: "Jackets",
    price: 498,
    compareAtPrice: null,
    image: "/img/product-11.webp",
    images: ["/img/product-11.webp"],
    colors: ["Olive Drab Green"],
    size: ["XS", "S", "M", "L", "XL", "XXL", "XXXL", "XXXXL"],
    material: "100% cotton whipcord shell with quilted lining",
    description: [
      "Military tanker styling is reworked in tightly woven olive whipcord for a refined but resilient outer layer.",
      "The insulated body and ribbed edges keep cold air out while preserving an uncluttered cropped silhouette.",
    ],
    attributes: {
      Weight: "12oz shell",
      Origin: "Japan",
      Fabric: "Cotton whipcord",
      Fit: "Regular military fit",
    },
    tags: ["military jacket", "whipcord", "tanker", "olive"],
    features: [
      "Quilted insulation",
      "Ribbed cuffs and hem",
      "Zip front",
      "Angled hand pockets",
    ],
    stock: 7,
    featured: false,
    newArrival: false,
  },
  {
    id: 12,
    name: "12oz Selvedge Denim Western Shirt - Indigo",
    sku: "IHSH-33-IND",
    brand: siteConfig.brandName,
    category: "Shirts",
    price: 274,
    compareAtPrice: null,
    image: "/img/product-12.webp",
    images: ["/img/product-12.webp"],
    colors: ["Indigo"],
    size: ["XS", "S", "M", "L", "XL", "XXL", "XXXL", "XXXXL"],
    material: "100% cotton Japanese selvedge denim",
    description: [
      "A substantial indigo western shirt that can be worn alone or as a light overshirt across seasons.",
      "Its shaped yokes and snap front bring definition to the robust fabric without unnecessary decoration.",
    ],
    attributes: {
      Weight: "12oz",
      Origin: "Japan",
      Fabric: "Selvedge denim",
      Fit: "Slim western fit",
    },
    tags: ["western shirt", "denim shirt", "12oz", "selvedge"],
    features: [
      "Snap front",
      "Western yokes",
      "Dual chest pockets",
      "Curved hem",
    ],
    stock: 19,
    featured: true,
    newArrival: false,
  },
  {
    id: 13,
    name: "12oz Wabash Western Shirt - Indigo",
    sku: "IHSH-62-IND",
    brand: siteConfig.brandName,
    category: "Shirts",
    price: 265,
    compareAtPrice: null,
    image: "/img/product-13.webp",
    images: ["/img/product-13.webp"],
    colors: ["Indigo"],
    size: ["XS", "S", "M", "L", "XL", "XXL", "XXXL", "XXXXL"],
    material: "100% cotton indigo Wabash fabric",
    description: [
      "Indigo Wabash cloth gives this western shirt a dotted stripe pattern with authentic workwear depth.",
      "The fitted shape layers neatly under a jacket while the fabric gains softness and contrast through regular use.",
    ],
    attributes: {
      Weight: "12oz",
      Origin: "Japan",
      Fabric: "Indigo Wabash cotton",
      Fit: "Slim western fit",
    },
    tags: ["western shirt", "wabash", "indigo", "workwear"],
    features: [
      "Snap front",
      "Western yokes",
      "Flap chest pockets",
      "Chain-stitched side seams",
    ],
    stock: 15,
    featured: false,
    newArrival: false,
  },
  {
    id: 14,
    name: "Ultra Heavy Flannel Buffalo Check Western Shirt - Red/Black",
    sku: "IHSH-232-RED",
    brand: siteConfig.brandName,
    category: "Shirts",
    price: 315,
    compareAtPrice: null,
    image: "/img/product-14.webp",
    images: ["/img/product-14.webp"],
    colors: ["Red/Black"],
    size: ["XS", "S", "M", "L", "XL", "XXL", "XXXL", "XXXXL"],
    material: "100% Aspero cotton ultra-heavy flannel",
    description: [
      "A bold red-and-black buffalo check gives this dense flannel an unmistakable cold-weather presence.",
      "Brushed cotton feels warm against the skin while the tailored western shape prevents bulky layering.",
    ],
    attributes: {
      Weight: "12oz",
      Origin: "Japan",
      Fabric: "Brushed Aspero cotton flannel",
      Fit: "Slim western fit",
    },
    tags: [
      "ultra heavy flannel",
      "buffalo check",
      "western shirt",
      "red black",
    ],
    features: [
      "Snap front",
      "Brushed interior",
      "Western yokes",
      "Flap chest pockets",
    ],
    stock: 11,
    featured: true,
    newArrival: false,
  },
  {
    id: 15,
    name: "19oz Selvedge Denim CPO Shirt - Indigo/Black",
    sku: "IHSH-409-IB",
    brand: siteConfig.brandName,
    category: "Shirts",
    price: 348,
    compareAtPrice: null,
    image: "/img/product-15.webp",
    images: ["/img/product-15.webp"],
    colors: ["Indigo/Black"],
    size: ["XS", "S", "M", "L", "XL", "XXL", "XXXL", "XXXXL"],
    material: "100% cotton indigo/black selvedge denim",
    description: [
      "A heavyweight CPO shirt designed to bridge the gap between structured shirting and a compact jacket.",
      "The indigo warp and black weft create a shadowed surface that will gain contrast along seams and pocket edges.",
    ],
    attributes: {
      Weight: "19oz",
      Origin: "Japan",
      Fabric: "Indigo/black selvedge denim",
      Fit: "Regular overshirt fit",
    },
    tags: ["CPO shirt", "19oz", "selvedge denim", "indigo black"],
    features: [
      "Snap front",
      "Oversized chest pockets",
      "Side-entry hand pockets",
      "Straight hem",
    ],
    stock: 10,
    featured: false,
    newArrival: true,
  },
  {
    id: 16,
    name: "7oz Cotton Linen Chambray Work Shirt - Indigo",
    sku: "IHSH-443-IND",
    brand: siteConfig.brandName,
    category: "Shirts",
    price: 290,
    compareAtPrice: null,
    image: "/img/product-16.webp",
    images: ["/img/product-16.webp"],
    colors: ["Indigo"],
    size: ["XS", "S", "M", "L", "XL", "XXL", "XXXL", "XXXXL"],
    material: "Cotton and linen chambray",
    description: [
      "A breathable cotton-linen chambray shirt with a dry touch suited to warmer days and light layering.",
      "Work-shirt pockets and a relaxed drape keep the refined indigo weave grounded in practical utility.",
    ],
    attributes: {
      Weight: "7oz",
      Origin: "Japan",
      Fabric: "Cotton-linen chambray",
      Fit: "Regular work-shirt fit",
    },
    tags: ["chambray", "cotton linen", "work shirt", "new arrival"],
    features: [
      "Button front",
      "Dual chest pockets",
      "Breathable weave",
      "Curved hem",
    ],
    stock: 21,
    featured: false,
    newArrival: true,
  },
  {
    id: 17,
    name: "6.5oz Loopwheel Crew Neck T-Shirt - White",
    sku: "IHT-1610-WHT",
    brand: siteConfig.brandName,
    category: "T-Shirts",
    price: 83,
    compareAtPrice: null,
    image: "/img/product-17.webp",
    images: ["/img/product-17.webp"],
    colors: ["White"],
    size: ["S", "M", "L", "XL", "XXL"],
    material: "100% cotton loopwheel jersey",
    description: [
      "A clean white crew neck knitted slowly for a soft hand and resilient shape.",
      "The midweight jersey works as a substantial standalone tee while remaining comfortable beneath an overshirt.",
    ],
    attributes: {
      Weight: "6.5oz",
      Origin: "Japan",
      Fabric: "Loopwheel cotton jersey",
      Fit: "Regular crew-neck fit",
    },
    tags: ["loopwheel", "crew neck", "white tee", "midweight"],
    features: [
      "Tubular body",
      "Ribbed neckline",
      "Short sleeves",
      "Reinforced shoulder seams",
    ],
    stock: 32,
    featured: false,
    newArrival: false,
  },
  {
    id: 18,
    name: "7.5oz Printed Loopwheel Crew Neck T-Shirt - Black",
    sku: "IHT-777-BLK",
    brand: siteConfig.brandName,
    category: "T-Shirts",
    price: 95,
    compareAtPrice: null,
    image: "/img/product-18.webp",
    images: ["/img/product-18.webp"],
    colors: ["Black"],
    size: ["S", "M", "L", "XL"],
    material: "100% cotton loopwheel jersey",
    description: [
      "A heavyweight black loopwheel tee finished with an original cut-number graphic for a subtle denim reference.",
      "Slow-knitted jersey provides a substantial feel and retains its structure through repeated wear.",
    ],
    attributes: {
      Weight: "7.5oz",
      Origin: "Japan",
      Fabric: "Printed loopwheel cotton jersey",
      Fit: "Regular crew-neck fit",
    },
    tags: ["loopwheel", "printed tee", "black", "new arrival"],
    features: [
      "Original front graphic",
      "Tubular body",
      "Ribbed neckline",
      "Heavyweight jersey",
    ],
    stock: 24,
    featured: false,
    newArrival: true,
  },
  {
    id: 19,
    name: "Waffle Knit Long Sleeved Thermal Henley - Indigo Dyed",
    sku: "IHTL-1213-IND",
    brand: siteConfig.brandName,
    category: "Knits",
    price: 195,
    compareAtPrice: null,
    image: "/img/product-19.webp",
    images: ["/img/product-19.webp"],
    colors: ["Indigo"],
    size: ["S", "M", "L", "XL", "XXL"],
    material: "100% cotton waffle knit",
    description: [
      "Indigo dye adds rich colour variation to this warm waffle-knit henley and will brighten naturally at raised texture.",
      "The close thermal shape layers smoothly while the button placket makes it polished enough to wear on its own.",
    ],
    attributes: {
      Weight: "Midweight",
      Origin: "Japan",
      Fabric: "Indigo-dyed waffle cotton",
      Fit: "Close thermal fit",
    },
    tags: ["thermal", "henley", "waffle knit", "indigo dyed"],
    features: [
      "Button placket",
      "Textured waffle knit",
      "Ribbed cuffs",
      "Long sleeves",
    ],
    stock: 18,
    featured: false,
    newArrival: false,
  },
  {
    id: 20,
    name: "Diamond Stitched 25oz Selvedge Denim Waist Bag - Indigo",
    sku: "IHE-51-IND",
    brand: siteConfig.brandName,
    category: "Accessories",
    price: 307,
    compareAtPrice: null,
    image: "/img/product-20.webp",
    images: ["/img/product-20.webp"],
    colors: ["Indigo"],
    size: ["One Size"],
    material: "25oz cotton selvedge denim",
    description: [
      "Diamond stitching gives this compact waist bag structure while highlighting the depth of extra-heavy indigo denim.",
      "An adjustable strap and organised compartments keep daily essentials secure without adding unnecessary bulk.",
    ],
    attributes: {
      Weight: "25oz body",
      Origin: "Japan",
      Fabric: "Diamond-stitched selvedge denim",
      Fit: "Adjustable one size",
    },
    tags: ["waist bag", "25oz", "selvedge denim", "diamond stitch"],
    features: [
      "Adjustable webbing strap",
      "Zipped main compartment",
      "Reinforced lining",
      "Internal organiser pocket",
    ],
    stock: 9,
    featured: false,
    newArrival: false,
  },
  {
    id: 21,
    name: 'Heavy Duty "Tochigi" Leather Belt with Nickel Plated Garrison Buckle - Brown',
    sku: "IHB-08-BRN",
    brand: siteConfig.brandName,
    category: "Accessories",
    price: 182,
    compareAtPrice: null,
    image: "/img/product-21.webp",
    images: ["/img/product-21.webp"],
    colors: ["Brown"],
    size: ["M", "L", "XL"],
    material: "Vegetable-tanned Tochigi leather",
    description: [
      "A thick brown leather belt designed to darken, polish and mould to the wearer with years of use.",
      "The restrained garrison buckle balances the substantial strap and suits both denim and work trousers.",
    ],
    attributes: {
      Weight: "Heavyweight",
      Origin: "Japan",
      Fabric: "Vegetable-tanned leather",
      Fit: "Three adjustable size ranges",
    },
    tags: ["leather belt", "Tochigi leather", "garrison buckle", "brown"],
    features: [
      "Nickel-plated buckle",
      "Single-prong closure",
      "Burnished edges",
      "Five adjustment holes",
    ],
    stock: 12,
    featured: false,
    newArrival: false,
  },
  {
    id: 22,
    name: "Iuturegarden “Bell” Print Bandana - Indigo",
    sku: "IHG-052-IND",
    brand: siteConfig.brandName,
    category: "Accessories",
    price: 54,
    compareAtPrice: null,
    image: "/img/product-22.webp",
    images: ["/img/product-22.webp"],
    colors: ["Indigo"],
    size: ["One Size"],
    material: "100% cotton fabric",
    description: [
      "A lightweight indigo bandana with a detailed bell motif created for versatile everyday styling.",
      "The cotton fabric softens quickly and can be worn at the neck, carried as a pocket square or tied to a bag.",
    ],
    attributes: {
      Weight: "Lightweight",
      Origin: "Japan",
      Fabric: "Printed cotton",
      Fit: "One size",
    },
    tags: ["bandana", "indigo", "printed cotton", "accessory"],
    features: [
      "All-over bell pattern",
      "Finished edges",
      "Square format",
      "Packable construction",
    ],
    stock: 27,
    featured: false,
    newArrival: false,
  },
  {
    id: 23,
    name: '8" Warren Boot - Black Roughout',
    sku: "IHWE-WAR-BLK",
    brand: siteConfig.brandName,
    category: "Footwear",
    price: 808,
    compareAtPrice: null,
    image: "/img/product-23.webp",
    images: ["/img/product-23.webp"],
    colors: ["Black"],
    size: [
      "US 8",
      "US 8.5",
      "US 9",
      "US 9.5",
      "US 10",
      "US 10.5",
      "US 11",
      "US 11.5",
      "US 12",
    ],
    material: "Black roughout leather with rubber outsole",
    description: [
      "An eight-inch lace-up boot cut from black roughout leather for grip, durability and a matte workwear finish.",
      "A supportive build and two width options make it suitable for long days while the understated profile pairs naturally with heavy denim.",
    ],
    attributes: {
      Weight: "Heavyweight",
      Origin: "United States",
      Fabric: "Black roughout leather",
      Fit: "D regular or E wide width",
    },
    tags: ["roughout leather", "lace-up boot", "8 inch", "work boot"],
    features: [
      "D and E width options",
      "Full lace closure",
      "Reinforced heel counter",
      "High-traction outsole",
    ],
    stock: 6,
    featured: true,
    newArrival: true,
  },
  {
    id: 24,
    name: '"Motorcycle Chain" Bracelet - Sterling Silver',
    sku: "IHSI-02",
    brand: siteConfig.brandName,
    category: "Accessories",
    price: 829,
    compareAtPrice: null,
    image: "/img/product-24.webp",
    images: ["/img/product-24.webp"],
    colors: ["Sterling Silver"],
    size: ["Regular", "Long"],
    material: "0.925 sterling silver",
    description: [
      "A substantial sterling silver bracelet whose articulated links take their rhythm from a mechanical drive chain.",
      "The polished surfaces and recessed details develop a nuanced patina that becomes more individual with wear.",
    ],
    attributes: {
      Weight: "Substantial silver weight",
      Origin: "Japan",
      Fabric: "0.925 sterling silver",
      Fit: "Regular or long length",
    },
    tags: ["sterling silver", "bracelet", "motorcycle inspired", "jewellery"],
    features: [
      "Articulated chain links",
      "Secure clasp",
      "Hand-finished surfaces",
      "Two length options",
    ],
    stock: 5,
    featured: true,
    newArrival: false,
  },
];

export default productData;
